/**
 * The keyboard jump hint, floated at the row's right edge while the jump
 * modifier is held. Ported from t3code's `JumpHintBadge`.
 *
 * An overlay pill rather than an inline slot, for the reason upstream gives:
 * the hint must not displace the status or time label, and holding the
 * modifier once blanked out "Working" when a slot displaced it. An overlay
 * also shifts no layout when it appears. It overlaps the archive/settle
 * controls it sits on top of, so it is `pointer-events-none` and never
 * swallows a click meant for them.
 *
 * `aria-hidden` because it is a redundant restatement of a keybinding the
 * shortcut layer already owns; announcing it beside every row is noise.
 *
 * Both row variants render it, and both position it against their own
 * surface: the compact row is `relative isolate`, the Activity card
 * `relative`.
 */
export function SidebarThreadJumpHint(props: {
  readonly label: string | null;
  readonly threadId: string;
}) {
  if (props.label === null) return null;
  return (
    <span
      aria-hidden
      data-testid={`thread-jump-hint-${props.threadId}`}
      className="pointer-events-none absolute top-1/2 right-1.5 z-10 inline-flex h-5 -translate-y-1/2 items-center rounded-full border border-border/80 bg-background/95 px-1.5 font-mono text-[10px] font-medium tracking-tight text-foreground shadow-sm"
    >
      {props.label}
    </span>
  );
}

export function SidebarThreadWorkItemBadge(props: { readonly workItemKey: string | null }) {
  if (props.workItemKey === null) return null;
  return (
    <span
      aria-label={`Work item ${props.workItemKey}`}
      className="rounded border border-border/70 bg-muted/70 px-1.5 py-0.5 text-[9px] font-semibold tracking-wide text-muted-foreground"
      data-testid={`thread-work-item-key-${props.workItemKey}`}
    >
      {props.workItemKey}
    </span>
  );
}
